import SVGInject from '@iconfu/svg-inject'
import Popup from '../plugins/PluginPopup.ts'

interface IItemDataPopupPlan {
  id: string
  map: string
  mask: string
  items: {
    id: string
    statusText: string
    statusColor: string
    area: string
    contact: string
    properties: {
      icon: string
      text: string
    }
    url: string
  }[]
}

// window.addEventListener('load', () => {
//   const planContainers = document.querySelectorAll('[data-popup-plan]')

//   if (planContainers.length === 0) return

//   planContainers.forEach((planContainer) => {
//     initializePopupPlan(planContainer)
//   })

// })

export const initializePopupPlanAlt = (container: Element) => {

  const planInfo = container.querySelector('[data-popup-plan-info]')
  const planItem = container.querySelector('[data-popup-plan-item]')

  const planData = planInfo?.getAttribute('data-popup-plan-info')

  if (!planInfo || !planData || !planItem) return

  const planJSON: IItemDataPopupPlan[] = JSON.parse(planData)

  Object.keys(planJSON).forEach((key, i) => {
    const itemNode = planItem.cloneNode(true) as Element
    /* remove template */
    planItem.remove()

    /* create clones of template */
    const clonedItem = planInfo.appendChild(itemNode)

    if (i !== 0) {
      clonedItem.classList.remove('active')
    }

    injectDataPopupPlan(clonedItem, planJSON, key, i)
  })
}

const injectDataPopupPlan = (
  item: Element,
  data: IItemDataPopupPlan[],
  key: string,
  i: number,
) => {
  const itemData = data?.[Number(key)]

  if (!itemData) return

  const planMap = item.querySelector('[data-popup-plan-map]')
  const planMapMask = item.querySelector('[data-popup-plan-map-mask]')
  // const planMapPopup = item.querySelector('[data-plan-popup]')

  // if (!planMap || !planMapMask || !planMapPopup) return
  if (!planMap || !planMapMask) return

  const staticMap = planMap.appendChild(document.createElement('img'))
  staticMap.src = `${itemData.map}`
  staticMap.alt = 'Static Map'

  const mask = planMapMask.appendChild(document.createElement('img'))
  mask.src = `${itemData.mask}`
  mask.alt = 'Map Mask'

  /* convert img to svg */
  SVGInject.setOptions({
    afterInject: () => {
      const paths = planMapMask.querySelectorAll('path')

      paths.forEach((path, index) => {
        const pathData = data[parseFloat(key)]['items'][index]

        if (pathData) {
          // add id attribute
          path.setAttribute('data-id', pathData.id)
          path.setAttribute('id', `${pathData.id}`)

          // add status color
          path.style.fill = pathData.statusColor
          path.style.opacity = '0.1'

          const bbox = path.getBBox()
          const x = bbox.x
          const y = bbox.y

          // Create a <text> element
          const textElem = document.createElementNS(
            path.namespaceURI,
            'foreignObject',
          )
          textElem.setAttribute('x', x.toString())
          textElem.setAttribute('y', y.toString())
          textElem.setAttribute('width', bbox.width.toString())
          textElem.setAttribute('height', bbox.height.toString())
          // Centre text horizontally at x,y
          textElem.setAttribute('text-anchor', 'middle')
          // Give it a class that will determine the text size, colour, etc
          textElem.classList.add('area')
          // Set the text
          textElem.innerHTML = `<div class="area__content">
            <div class="area__number">${index + 1}.</div>
            <div class="area__info">
              <h5 ${pathData.statusColor
              ? `style="color:${pathData.statusColor}"`
              : ''
            }>${pathData.area} m<sup>2</sup></h5>
              <span>${pathData.statusText}</span>
            </div>
          </div>
          `
          // Add this text element directly after the label background path
          path.after(textElem)

          setTimeout(() => {
            getDataPopupPlan(pathData, textElem)
          }, 200)
        }
      })
    },
  })
  SVGInject(mask)
}

const getDataPopupPlan = (data: any, textElem: Element) => {
  const template = document.querySelector(`[data-item="content-popup"]`)

  new Popup({
    trigger: 'click',
    openBtn: textElem,
    title: '',
    content: '',
    isTemplate: true,
    template: template,
    iconClose: false,
    btnClose: true,
    btnCloseContent: '',
    customClass: 'popup-rent--alt',
    onAfterOpen() {
      const id = textElem.getAttribute('data-id')
      const url = data.url
      const popup = document.querySelector(`[data-popup="true"]`)

      if (popup) {
        const content = popup.querySelector(`[data-popup="content"]`)
        console.log(url)
        if (url) {
          fetch(url, {
            method: 'get',
          })
            .then((res) => {
              return res.text()
            })
            .then((data) => {
              if (content) {
                // Add new content
                content.insertAdjacentHTML('afterbegin', data)

                const svg = content.querySelectorAll(`[data-item="svg"]`)
                SVGInject.setOptions({
                  afterInject: null,
                })
                SVGInject(svg)
                // content.innerHTML = data

                const scrollsContainer = popup.querySelector(
                  `[data-popup="wrapper"]`,
                )
                if (scrollsContainer) {
                  // scrollsContainers.forEach((container) => {
                  // Check if custom srcoll has ben alread init on this container
                  if (
                    scrollsContainer.getAttribute(
                      'data-custom-scroll-active',
                    ) != 'true'
                  ) {
                    scrollsContainer.setAttribute(
                      'data-custom-scroll-active',
                      'true',
                    )

                    new window.simplebar(scrollsContainer, {
                      autoHide: false,
                    })
                  }
                  // })
                }

                setTimeout(() => {
                  content.classList.remove('hidden')

                  const popupPlanContainers =
                    content.querySelector('[data-popup-plan]')

                }, 200)
              }
            })
        }
      }
    },
  })
  // textElem.addEventListener('click', () => {
  //   const formEmailInput = document.querySelector(
  //     `[data-item="popup-contact-email"]`,
  //   )
  //   const properties = document.querySelector(`[data-properties]`)

  //   if (formEmailInput) {
  //     formEmailInput.setAttribute('value', data.contact)
  //   }

  //   if (properties) {
  //     let body = ``

  //     // for (const [key, value] of Object.entries(data.properties)) {
  //     Object.entries(data.properties).forEach((key, value) => {
  //       body += `<li class="list__item d-flex align-items-center">
  //         <figure class="list__icon">
  //             <img src="${data.properties[value].icon}" data-item="svg" alt="icon" class="icon">
  //         </figure>
  //         <span class="text__alfa weight__light">${data.properties[value].text}</span>
  //     </li>`
  //     })

  //     properties.classList.add('hidden')
  //     properties.innerHTML = body

  //     const svg = properties.querySelectorAll(`[data-item="svg"]`)
  //     SVGInject.setOptions({
  //       afterInject: null,
  //     })
  //     SVGInject(svg)

  //     setTimeout(() => {
  //       properties.classList.remove('hidden')
  //     }, 100)
  //   }
  // })
}
